import pino from 'pino';
/**
 * Structured logger for Lambda functions
 * Uses Pino for JSON-formatted logging compatible with CloudWatch
 *
 * Per ADR-011 (Logging Technology Choice)
 */
export const logger = pino({
    level: process.env.LOG_LEVEL || 'info',
    formatters: {
        level: (label) => ({ level: label }),
    },
    // CloudWatch Logs prefers ISO timestamps
    timestamp: pino.stdTimeFunctions.isoTime,
});
/**
 * Create a child logger with additional context
 * Useful for adding request-scoped information
 *
 * @example
 * const requestLogger = createLogger({ requestId: '123', userId: 'user-456' });
 * requestLogger.info({ msg: 'Processing request' });
 */
export const createLogger = (context) => {
    return logger.child(context);
};
//# sourceMappingURL=logger.js.map